import { makeRequest } from '../../../../lib/api';

const PARTNER_CONTRACT_FEES_PATH = '/v1/partner_contract_fees';
const PARTNER_CONTRACT_PATH = '/v1/partner_contracts';
const PARTNER_LEGAL_SERVICE_PATH = '/v1/partner_legal_service';

class partnerFeeController {
  /** блок управления договорами партнёра и юр.лица */
  // список договоров по юр.лицу
  getLegalContractList = (partnerLegalId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_PATH }/legal/${ partnerLegalId }`);
  };

  // список договоров по партнёру
  getPartnerContractList = (partnerId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_PATH }/partner/${ partnerId }`);
  };

  getContract = (id) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_PATH }/${ id }`);
  };

  createContract = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CONTRACT_PATH }`, data);
  };

  updateContract = (data = {}) => {
    return makeRequest('put', `${ PARTNER_CONTRACT_PATH }/${ data.id }`, data);
  };

  deleteContract = (id) => {
    return makeRequest('delete', `${ PARTNER_CONTRACT_PATH }/${ id }`);
  };

  // данные по одному объекту с комиссиями
  getPartnerContractFee = (partnerContractFeesId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_FEES_PATH }/${ partnerContractFeesId }`);
  };

  // Список комиссий по договору
  getPartnerFeeByContract = (partnerContractId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_FEES_PATH }/partner_contract/${ partnerContractId }`);
  };

  // Список комиссий по конкретному региону-сервису-партнёру
  getPartnerFeeByServicePartner = (servicePartnerId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_FEES_PATH }/service_partner/${ servicePartnerId }`);
  };

  // Список комиссий по конкретному офису
  getPartnerFeeByServiceOffice = (serviceOfficeId) => {
    return makeRequest('get', `${ PARTNER_CONTRACT_FEES_PATH }/service_office/${ serviceOfficeId }`);
  };

  // Список комиссий по конкретному партнёру
  getPartnerFeeByPartner = (data) => {
    return makeRequest('post', `${ PARTNER_CONTRACT_FEES_PATH }/find`, data);
  };

  createContractService = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CONTRACT_FEES_PATH }`, data);
  };

  updateContractService = (data = {}) => {
    return makeRequest('put', `${ PARTNER_CONTRACT_FEES_PATH }/${ data.id }`, data);
  };

  deleteContractService = (partnerContractFeesId) => {
    return makeRequest('delete', `${ PARTNER_CONTRACT_FEES_PATH }/${ partnerContractFeesId }`);
  };

  // Управление комиссиями по юр.лицу (AV-6219)

  createContractLegalFee = (data = {}) => {
    return makeRequest('post', `${ PARTNER_LEGAL_SERVICE_PATH }`, data);
  };

  updateContractLegalFee = (data = {}) => {
    return makeRequest('put', `${ PARTNER_LEGAL_SERVICE_PATH }/${ data.partnerLegalServiceId }`, data);
  };

  deleteContractLegalFee = (partnerLegalServiceId) => {
    return makeRequest('delete', `${ PARTNER_LEGAL_SERVICE_PATH }/${ partnerLegalServiceId }`);
  };
}

export default new partnerFeeController();
